<div class="sign-up-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div
                class="altair-form ml-auto mr-auto border-radius bg-white"
                [class.card-borderd-theme]="themeService.isCardBorder()"
                [class.component-dark-theme]="themeService.isDark()"
                [class.rtl-enabled]="themeService.isRTLEnabled()"
            >
                <div class="title text-center">
                    <h3>
                        Inscribirse
                    </h3>
                    <p class="text-black">
                        ¿Ya tienes una cuenta? <a routerLink="/authentication" class="text-altair">Iniciar Sesión</a>
                    </p>
                </div>
                <form [formGroup]="authForm" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <label class="main-label d-block lh-1 text-black">
                            Nombre
                        </label>
                        <mat-form-field>
                            <mat-label>
                                Ingrese su nombre
                            </mat-label>
                            <input matInput type="text" id="name" formControlName="name">
                        </mat-form-field>
                        <div class="error text-danger" *ngIf="authForm.get('name')!.hasError('required') && authForm.get('name')!.touched">
                            Se requiere el nombre.
                        </div>
                        <div class="error text-danger" *ngIf="authForm.get('name')!.hasError('name') && authForm.get('name')!.touched">
                            Por favor ingrese un nombre válido.
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="main-label d-block lh-1 text-black">
                            Dirección De Correo Electrónico
                        </label>
                        <mat-form-field>
                            <mat-label>
                                Introducir la dirección de correo electrónico
                            </mat-label>
                            <input matInput type="email" id="email" formControlName="email">
                        </mat-form-field>
                        <div class="error text-danger" *ngIf="authForm.get('email')!.hasError('required') && authForm.get('email')!.touched">
                            El correo electronico es requerido.
                        </div>
                        <div class="error text-danger" *ngIf="authForm.get('email')!.hasError('email') && authForm.get('email')!.touched">
                            Por favor, introduce una dirección de correo electrónico válida.
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="main-label d-block lh-1 text-black">
                            Contraseña
                        </label>
                        <mat-form-field>
                            <mat-label>
                                Ingresa tu contraseña
                            </mat-label>
                            <input matInput [type]="hide ? 'password' : 'text'" id="password" formControlName="password">
                            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                                <span class="material-symbols-outlined">
                                    {{hide ? 'visibility_off' : 'visibility'}}
                                </span>
                            </button>
                        </mat-form-field>
                        <div class="error text-danger" *ngIf="authForm.get('password')!.hasError('required') && authForm.get('password')!.touched">
                            Se requiere contraseña.
                        </div>
                        <div class="error text-danger" *ngIf="authForm.get('password')!.hasError('minlength') && authForm.get('password')!.touched">
                            La contraseña debe tener al menos 8 caracteres.
                        </div>
                    </div>
                    <mat-checkbox>
                        Acepto los <a href="javascript:void(0);" class="text-altair">Términos y condiciones</a>
                    </mat-checkbox>
                    <button mat-button class="btn" type="submit" [disabled]="authForm.invalid">
                        Inscribirse
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>
